var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBulletpoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 5.75C1.30833 5.75 0.75 6.30833 0.75 7C0.75 7.69167 1.30833 8.25 2 8.25C2.69167 8.25 3.25 7.69167 3.25 7C3.25 6.30833 2.69167 5.75 2 5.75ZM2 0.75C1.30833 0.75 0.75 1.30833 0.75 2C0.75 2.69167 1.30833 3.25 2 3.25C2.69167 3.25 3.25 2.69167 3.25 2C3.25 1.30833 2.69167 0.75 2 0.75ZM2 10.75C1.30833 10.75 0.75 11.3167 0.75 12C0.75 12.6833 1.31667 13.25 2 13.25C2.68333 13.25 3.25 12.6833 3.25 12C3.25 11.3167 2.69167 10.75 2 10.75ZM4.5 12.8333H16.1667V11.1667H4.5V12.8333ZM4.5 7.83333H16.1667V6.16667H4.5V7.83333ZM4.5 1.16667V2.83333H16.1667V1.16667H4.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulletpoint);
export default __webpack_public_path__ + "static/media/bulletpoint.652e95528001e3a98a18439cd22eac7b.svg";
export { ForwardRef as ReactComponent };